import React, {Fragment} from 'react'
import { graphql, StaticQuery, Link } from 'gatsby'
import Header from '../components/Header'
import CancelAlbert from '../assets/good-news_new.svg'


class Cancel extends React.Component{
    constructor(props){
        super(props)

        this.state = {
            loading: false,
            disabled: false
        }
    }

    render(){
        const {  appleLogo, googleLogo } = this.props.query;
        return(
            <Fragment>
				<Header logoColor="#32e2b9" classStatic="webinfo" dropDownColor="black" page='senior'  title="Albert"/>
				
                <section className="lamma-oss webinfo__Section">
                    <div className="custom-container">
                        <h1>Hej kära medlem,</h1>
                        <p className="desktop">Vi har valt att stänga webbversionen av Junior. Vi hänvisar <br/> dig att ladda ner vår app istället, där kan ni fortsätta öva och få <br/> ut det bästa av Junior. Appen finns tillgänglig på App Store och Google Play.</p>
                        <p className="for-mobile">Vi har valt att stänga webbversionen av <br/> Junior. Vi hänvisar dig att ladda ner vår app istället, <br/> där kan ni fortsätta öva och få ut det bästa <br/> av Junior. Appen finns tillgänglig på <br/> App Store och Google Play.</p>
                        
                        <div class="app-store" style={{ marginTop: '55px'}}>
                        <a style={{display: 'inline-block', marginRight: '20px'}} href="https://apps.apple.com/se/app/albert-junior/id1486597368" target="_blank"><img style={{marginBottom: 0}} src={appleLogo.publicURL}/></a>
                        <a style={{display: 'inline-block', marginRight: '20px'}} href="https://play.google.com/store/apps/details?id=se.mralbert.junior&hl=en" target="_blank"><img style={{marginBottom: 0}} src={googleLogo.publicURL}/></a>
                        </div>
                        {/* <a href="https://login.hejalbert.se/auth/login" className="forst-btn">Jag förstår, ta mig till webbversion</a> */}
                    </div>
                </section>

                <section className="img__section_onpage">
                    <div className="custom-container">
                       <figure><CancelAlbert/></figure>
                     </div>
                </section>
            </Fragment>
        )
    }
}

export default (props) => (
    <StaticQuery
        query= { graphql`
                query {
                    appleLogo: file(relativePath: {regex: "/app-store/"}){
                        publicURL
                    }
                    googleLogo: file(relativePath: {regex: "/google-black-play/"}){
                        publicURL
                    }
                }`
            }
        render={(data)  => (
           <Cancel query={data} {...props}/>
        )}
    />
)